import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
    "poolPower":{
        value:'311.49',
        unit:'pib'
    },
    "dailyOutput":{
        value:'35',
    },
    "dailyIncome":{
        value:'0.21',
        unit:'XCH/PiB',
    },
    "dailyIncomeTotal":{
        value:'$39.52200000',
        unit:'PiB',
    },
    "distributeMode":{
        value:'PPLNS',
    },
    "serviceFee":{
        value:'1',
        unit:'%',
    },
    "settleTime":{
        value:'12:00:00',
        unit:'(UTC+8)',
    },
    "withdrawalAmount":{
        value:'0.05000000',
        unit:'XCH',
    },
    "withdrawalFee":{
        value:'0.1',
        unit:'%',
    },
    "withdrawalReviewTime":{
        value:'24:00',
        unit:'h',
    },
}
/* eslint-disable global-require */
mock.onGet('/mainOther/data').reply(() => [200, data])